import React from 'react';
import RichText from '../ui/RichText';
import '../../css/layout/PageHeader.css';

const PageHeader = ({ title, subtitle }) => {
  return (
    <section className="page-header">
      <h1 className="page-title">{title}</h1>
      {subtitle != null && subtitle !== '' && (
        <RichText value={subtitle} className="page-subtitle" />
      )}
    </section>
  );
};

export default PageHeader; 